import { HcAlert } from '@cosmos-web/hc-alert'
import clsx from 'clsx'

import styles from './alert.module.css'

const Alert = (props: typeof HcAlert.defaultProps): JSX.Element => {
  return (
    <HcAlert {...props} className={clsx(props?.className, styles.alert)}>
      {props?.children}
    </HcAlert>
  )
}

export default Alert
